<template>
    <section class="content">
        <loading :active.sync="isLoading" :color="'#39a2db'" :loader="'dots'" :is-full-page="true"></loading>
        <div class="container-fluid">
            <div  class="row">
                <div v-for="row in optMapel" v-bind:key="row.paket_id"
                v-bind:value="row.paket_id" class="col-md-4 col-sm-8 col-12">
                <router-link :to="{
                    path: '/rapor/type/'+row.type_name+'/'+filter.ujian_type,
                }">
                    <div class="info-box shadow-sm">
                    <span class="info-box-icon bg-info"><i class="fas fa-cubes"></i></span>
                    <div class="info-box-content">
                        <span class="info-box-text"><h2>{{ row.type_name }}</h2></span>                        
                    </div>
                    </div>
                </router-link>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { authFetch } from "@/libs/hxcore";
import pageLoading from '@/mixins/pageLoading';
export default {
    mixins: [pageLoading],
    name: 'UjianMapelType',
    data: () => ({
        optMapel: [],
        filter: {},
    }),
    created: function () {
        if(this.$route.params.filter) {
        this.filter = this.$route.params.filter;
        console.log(this.filter)
        }
        
        if(Object.keys(this.filter).length<1)
        {
        if(sessionStorage.filterData)this.filter = JSON.parse(sessionStorage.filterData);
        }
        else{
        sessionStorage.filterData = JSON.stringify(this.filter);
        sessionStorage.filterStatus = 1;
        }

        this.loadUjian(this.filter);
    },
    methods: {
        loadUjian(params){
            let data = '';
            data = Object.keys(params)
            .map(
            (key) =>
                encodeURIComponent(key) + "=" + encodeURIComponent(params[key])
            )
            .join("&");
            this.isLoading = true;
            authFetch("/siswa/ujian/type?"+data)
                .then((res) => res.json())
                .then((json) => {
                    if (json.success) {
                        this.optMapel = json.data;
                    }
                })
                .catch(() => {})
                .finally(() => { this.isLoading = false; });
        }
    },
    mounted(){
        // this.loadUjian();
    },
}
</script>
<style type="text/css" scoped>
</style>